export default __webpack_public_path__ + "static/media/aventuras.92e3720c.svg";